<template>
    <tag :class="bootstrapClass[lowerCaseTenantDomainTheme]" :is="tag">
        <slot></slot>
    </tag>
</template>

<script>
import Tag from '../../../../Utility/Tag.vue';
import {tenantDomainTheme} from "../../../../../mixins/tenantDomainTheme";

export default {
    name: 'ThemedBootstrapCardHeader',

    components: {
        Tag,
    },

    mixins: [
        tenantDomainTheme,
    ],

    props: {
        tag: {
            default: 'div',
            required: false,
            type: String,
        },
    },

    data() {
        return {
            bootstrapClass: {
                artificialreason: 'panel-heading',
                assan: 'card-header',
                eventrac: 'box-header with-border',
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/Bootstrap/Bootstrap/Card/ThemedBootstrapCardHeader.vue